module.exports = __webpack_public_path__ + "static/media/uni-bg1.af6c509e.png";